<template>
<div>
  <OverlayLoading :loading="loading" />
  <v-dialog v-model="dialogApprover" persistent max-width="500px">
    <v-card class="pl-4 pr-4  pt-2 pb-2" style="border-radius: 16px;">
      <v-card-actions>
      <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
      </v-card-actions>
      <v-card-title>
        <span class="ra-head-text-bold pb-2 mt-n4" style="color: black;font-size: 18px;">{{typeAction}}ผู้ดูแล</span>
      </v-card-title>
      <v-divider class="mr-6 ml-6"></v-divider>
      <v-card-text>
        <!-- <v-row class="align-center" justify="start">
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
          <v-col cols="12">
            <span class="ra-head-text" style="">เลือกผู้ดูแล</span>
          </v-col>
          <div class="">
            <v-radio-group
              v-model="radios"
              row
              >
              <v-radio
                class="radio-border"
                label="ตนเอง"
                value="ตนเอง"
              ></v-radio>
              <v-radio
                class="radio-border"
                label="ค้นหาจากรหัสพนักงาน"
                value="ค้นหาจากรหัสพนักงาน"
              ></v-radio>
            </v-radio-group>
          </div>
        </v-row> -->
        <v-row>
          <v-col cols="12">
            <v-autocomplete
              v-model="dataSearchEmployee"
              @change="searchEmployee(dataSearchEmployee)"
              :items="itemUser"
              item-text="dataShow"
              item-value="emailOneId"
              :search-input.sync="searchEmpoyee"
              outlined
              dense
              class="mt-2"
              placeholder="ค้นหาได้จากชื่อนามสกุล หรือ อีเมล One ID "
              no-data-text="ไม่พบข้อมูล"
              @keyup="getUser($event.target.value)"
            >
              <template v-slot:append>
                <img width="18" height="18" src="@/assets/icons/search-icon-2.png">
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="pl-3 mb-2">
          <span>ผลการค้นหา</span>
        </v-row>
        <div class="pa-3" style="background-color: #F8F9FB; height: 230px; border-radius: 9px;">
          <!-- <v-avatar
            v-if="searchEmpoyee !== null || employeeIdDefault !==''"
            class="mt-1 ml-2"
            size="80"
            rounded
            style="float: left;"
            >
            <v-img
              class="card-header-userimg-border"
              cover
              :lazy-src="require('@/assets/icons/no_user.png')"
              :src="failed_image ? require('@/assets/icons/no_user.png') : img"
              :alt="employeeId"
              v-on:error="onImgError()"
              aspect-ratio="1"
              height="100%"
            />
          </v-avatar> -->
          <v-row v-if="searchEmpoyee !== null || employeeIdDefault !==''" class="pl-4 pr-4 pt-2 mb-5 align-center">
            <!-- <v-col cols="8" class="form-control">
              <p class="txt-font" style="margin-top: 0%;">รหัสพนักงาน</p>
              <span class="txt-font" style="color: #333;">{{employeeId}}</span>
            </v-col> -->
            <v-col cols="8" class="form-control">
              <p class="txt-font" style="margin-top: 0%; font-size: 14px;">ชื่อ-สกุล</p>
              <span class="txt-font" style="color: #333;font-size: 14px;">{{fNameTh}}</span>
            </v-col>
            <v-col cols="8" class="form-control">
              <p class="txt-font" style="margin-top: 0%; font-size: 14px;">อีเมล</p>
              <span class="txt-font" style="color: #333;font-size: 14px;">{{email}}</span>
            </v-col>
            <v-col cols="8" class="form-control">
              <p class="txt-font" style="margin-top: 0%; font-size: 14px;">เบอร์โทรศัพท์</p>
              <span class="txt-font" style="color: #333;font-size: 14px;">{{tel}}</span>
            </v-col>
          </v-row>
          <v-row v-else class="pl-3" justify="center" style="padding: 90px 0;">
            <span class="ra-head-text">ไม่มีข้อมูล</span>
          </v-row>
        </div>
        <!-- <FullLoading :loading="loadingUsers"></FullLoading> -->
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="button-color-outline mr-4" width="18%" outlined @click="closeDialog">ยกเลิก</v-btn>
        <v-btn v-if="searchEmpoyee === '' || searchEmpoyee === null" width="18%" class="ma-2" color="grey" depressed disabled style="color:white">ยืนยัน</v-btn>
        <v-btn v-else class="button-color" width="18%" dark @click="confirmApprove()">ยืนยัน</v-btn>
        <!-- <v-btn v-if="type === 'temporaryer'" class="ra-button1" color="#1654C6" dark @click="confirmApprove()">เพิ่มผู้รักษาการ</v-btn> -->
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
// import { UpdateTitleOrgchart, FullLoading } from '@/components/index'
import {
  getUserByLogin, // ใหม่
  // getUserByKeyword, // เก่า
  // searchSelectEmployee,
  hostImageUrlv3
} from '@/API/API'
import { EventBus } from '@/EventBus'
import swal from 'sweetalert'
import OverlayLoading from '../../_template/OverlayLoading'

export default {
  name: 'dialog-create-approver',
  components: {
    // FullLoading,
    // UpdateTitleOrgchart
    OverlayLoading
  },
  data () {
    return {
      isLoading: false,
      loading: false,
      loadingUsers: true,
      dialogApprover: false,
      failed_image: false,
      radios: null,
      employeeIdDefault: '',
      propsEmpId: '',
      serviceType: '',
      serviceName: '',
      note: '',
      formId: '',
      senderName: '',
      dataCreate: '',
      chkRole: 'admin',
      fNameTh: '',
      lNameTh: '',
      email: '',
      approveType: 'ผู้อนุมัติ',
      companyName: '',
      companyId: '',
      tel: '',
      img: '',
      employeeId: '',
      id: '',
      position: '',
      userImg: '',
      dataSearchEmployee: '',
      action: '',
      type: '',
      index: '',
      items: [],
      itemUser: [],
      search: null,
      select: null,
      searchEmpoyee: null,
      typeAction: '',
      tokenUser: '',
      rulesSearch: [
        v => !!v || 'กรุณากรอก Username หรือ E-mail'
      ]
    }
  },
  beforeDestroy () {
    EventBus.$off('openDialogAddAprover')
  },
  mounted () {
    EventBus.$on('openDialogAddAprover', this.openDialogAddAprover)
  },
  watch: {
    async radios (val) {
      if (val === 'ตนเอง') {
        this.img = ''
        this.employeeIdDefault = ''
        this.employeeIdDefault = this.$store.state.user.employeeId
        await this.searchEmployee(this.$store.state.user.employeeId)
      } else if (val === 'ค้นหาจากรหัสพนักงาน') {
        this.failed_image = false
        // this.dataSearchEmployee = ''
        this.employeeIdDefault = ''
        this.img = ''
        this.id = ''
        this.fNameTh = ''
        this.employeeId = ''
        this.position = ''
        this.email = ''
        this.companyName = ''
        this.companyId = ''
        // this.getUser()
      } else if (val === 'ค้นหาจาก One ID') {
        this.failed_image = false
        this.dataSearchEmployee = ''
        this.employeeIdDefault = ''
        this.img = ''
        this.id = ''
        this.fNameTh = ''
        this.employeeId = ''
        this.position = ''
        this.email = ''
        this.companyName = ''
        this.companyId = ''
        // this.searchEmployeeOne()
      }
    }
  },
  created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.propsEmpId = this.$route.params.id
    this.tokenUser = this.$store.state.token
    // this.getUser()
  },
  methods: {
    onImgError () {
      this.failed_image = true
    },
    async openDialogAddAprover (value, item, action, index, type) {
      // this.onImgError()
      // console.log('Data Dialog:', value, type, item, action, index)
      this.loading = true
      this.getUser(item.email)
      this.searchEmpoyee = ''
      this.employeeIdDefault = ''
      this.dataSearchEmployee = ''
      this.img = ''
      this.radios = null
      this.action = action
      this.index = index
      this.type = type
      // this.dataSearchEmployee = item.approverName // ถ้ามี employeeId ค่อยเปิด
      this.dataSearchEmployee = item.email
      // this.dialogApprover = value
      if (this.action === 'edit') {
        this.typeAction = 'แก้ไข'
        this.radios = 'ค้นหาจากรหัสพนักงาน'
        // await this.searchEmployee(item.approverName) // มี employeeId ค่อยเปิด
        await this.searchEmployee(item.email)
        // this.searchEmpoyee = item.approverName // มี employeeId ค่อยเปิด
        this.searchEmpoyee = item.email
      } else if (this.action === 'add') {
        this.typeAction = 'เพิ่ม'
        // console.log('add')
      }
    },
    closeDialog () {
      this.clearSearchEmployee()
      this.dialogApprover = false
    },
    clearSearchEmployee () {
      this.loadingUsers = true
      this.radios = null
      this.dataSearchEmployee = ''
      this.searchEmpoyee = ''
      this.fNameTh = ''
      this.lNameTh = ''
      this.employeeId = ''
      this.position = ''
      this.email = ''
      this.img = ''
      this.id = ''
      this.tel = ''
      this.companyName = ''
      this.loadingUsers = false
    },
    async getUser (value) {
      // this.loading = true
      this.loadingUsers = true
      var temp = []
      const obj = {
        name: value
      }
      try {
        // const res = await getUserByKeyword(obj, this.tokenUser) // เก่า
        const res = await getUserByLogin(obj, this.tokenUser) // ใหม่
        // console.log('res', res)
        if (res.success) {
          if (res.selector.length) {
            res.selector.map((el, index) => {
              if (el.userImg === '') {
                el.userImg = `${hostImageUrlv3}/_/${el.emailOneId}`
              } else {
                el.userImg = `${hostImageUrlv3}/${el.userImg}/${el.emailOneId}`
              }
              temp.push({
                no: index + 1,
                dataShow: el.titleTh + el.name + ' - ' + el.emailOneId,
                ...el
              })
            })
          }
          // temp = res.result
          this.itemUser = temp
          this.loading = false
          this.dialogApprover = true
        }
      } catch (error) {
        console.log(error)
      } finally {
        // this.loading = false
        this.loadingUsers = false
      }
    },
    async searchEmployee (value) {
      // this.loading = true
      // this.loadingUsers = true
      const obj = {
        // search: value
        name: value
      }
      try {
        // const res = await getUserByKeyword(obj, this.tokenUser) // เก่า
        const res = await getUserByLogin(obj, this.tokenUser) // ใหม่
        // console.log('Res add approver', res)
        if (res.selector[0]) {
          // console.log('///', res.selector[0])
          this.id = res.selector[0]._id
          this.fNameTh = res.selector[0].titleTh + res.selector[0].name
          // this.employeeId = res.result[0].employeeId
          // this.position = res.result[0].position.positionName
          this.email = res.selector[0].emailOneId
          this.img = res.selector[0].userImg
          // this.companyName = res.result[0].companyName
          // this.companyId = res.result[0].companyId
          this.tel = res.selector[0].tel
          if (this.img === '') {
            this.img = `${hostImageUrlv3}/_/${res.selector[0].emailOneId}`
          } else {
            this.img = `${hostImageUrlv3}/${res.selector[0].userImg}/${res.selector[0].emailOneId}`
          }
        } else {
          this.dataSearchEmployee = ''
          swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
            button: false,
            timer: 2000
          })
        }
      } catch (error) {
        this.dataSearchEmployee = ''
        swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
          button: false,
          timer: 2000
        })
      } finally {
        // this.loading = false
        this.loadingUsers = false
      }
    },
    confirmApprove () {
      // if (this.dataSearchEmployee === '' || this.employeeId === '') {
      if (this.dataSearchEmployee === '') {
        swal('คำเตือน', 'กรุณากรอกชื่อหรืออีเมล One ID ที่ต้องการค้นหา', 'warning', {
          button: false,
          timer: 2000
        })
      } else {
        var valueList = {
          id: this.id,
          name: this.fNameTh,
          // employeeId: this.employeeId,
          nickname: '',
          // position: this.position,
          email: this.email,
          // approveType: this.approveType,
          // companyId: this.companyId,
          tel: this.tel,
          userImg: this.img
        }
        EventBus.$emit('addAprover', valueList, this.index, this.action, this.type)
        this.type = ''
        this.dialogApprover = false
        this.fNameTh = ''
        this.lNameTh = ''
        this.employeeId = ''
        this.position = ''
        this.email = ''
        this.companyName = ''
        this.img = ''
        this.tel = ''
        this.onImgError()
        // swal('Success', 'โอนย้ายสิทธิ์ สำเร็จ', 'success')
      }
    }
  }
}
</script>
<style scoped>
@import '../../../css/ManageEmployee.css';
.txt-font {
  /* font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px; */
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 5px;
  color: #757575;
}
.txt-head {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
}
.ra-button {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 9px 24px;

  position: absolute;
  width: 157px;
  height: 36px;

  /* Color / Primary / Default */

  background: #3776E9;
  border-radius: 4px;
}
.ra-text-in-button {
  font-family: 'Sarabun', sans-serif;
  /* font-weight: normal; */
  font-style: normal;
  font-weight: 200;
  font-size: 14px;
}
.ra-head-text-bold {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* Color / Primary / Hover */

  color: #1654C6;
}
.ra-head-text {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
}
.box-image3 {
  border-width: 1px 1px;
  border-radius: 5px;
  border: 2px solid #e7e7e7;
  height: 40px;

}
.radio-border {
  height: 45px;
  border: 2px solid #ddd;
  border-radius: 5px;
  padding: 15px;
}
.radio-border-click {
  height: 45px;
  border: 2px solid blue;
  border-radius: 5px;
  padding: 15px;
}
.v-input--radio-group.v-input--radio-group--row .v-radio .radio-border-click {
  border-color: red;
}
/* .v-input--radio-group .v-input--radio-group--row .v-radio {
  border-color: red;
} */
/* .radio-border[data-v-c437d5c2] {
  height: 45px;
  border: 2px solid blue;
  border-radius: 5px;
  padding: 15px;
} */
</style>
